/**
 * Business-configured rules: which payment modes require a transaction/reference ID at checkout.
 */

export function isDefaultTransIdRequired(modeId, dpaymethodsRequireTransId) {
  return (
    Array.isArray(dpaymethodsRequireTransId) &&
    dpaymethodsRequireTransId.includes(Number(modeId))
  );
}

/** Split / "Multiple" mode: required if any non-zero slice uses a default method ID flagged as required. */
export function multipleSplitRequiresTransId(payInfo, dpaymethodsRequireTransId) {
  const req = dpaymethodsRequireTransId || [];
  const pairs = [
    [1, parseFloat(payInfo.cash_amt)],
    [2, parseFloat(payInfo.cc_amt)],
    [3, parseFloat(payInfo.upi_amt)],
    [4, parseFloat(payInfo.wallet_amt)],
  ];
  return pairs.some(
    ([id, amt]) => !Number.isNaN(amt) && amt > 0.009 && req.includes(id)
  );
}

/**
 * Optional: empty OK; if user types something, enforce min 4 chars (existing app rule).
 * Required: min 4 chars after trim.
 */
export function validateBusinessTransId(transId, required) {
  const t = String(transId ?? "").trim();
  if (!required) {
    if (t.length === 0) return { ok: true };
    if (t.length < 4) {
      return {
        ok: false,
        message:
          "Enter at least 4 characters for Transaction ID, or leave it empty.",
      };
    }
    return { ok: true };
  }
  if (t.length < 4) {
    return {
      ok: false,
      message:
        t.length === 0
          ? "Transaction ID is mandatory."
          : "Enter at least 4 characters for Transaction ID.",
    };
  }
  return { ok: true };
}
